import styled, { css } from 'styled-components'

type ServicesInfoProps = {
  darkTheme?: boolean
}

export const ServicesSection = styled.section<ServicesInfoProps>`
  padding: 1.6875rem 0 1.375rem 0;
  ${({ darkTheme }) =>
    darkTheme &&
    css`
      background-color: #141723 !important;

      span,
      a,
      strong,
      h1,
      h2,
      h3,
      h4,
      button,
      p {
        color: #fff !important;
      }
    `}
`

export const ServicesReponsive = styled.div`
  @media (max-width: 30rem) {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 1.25rem;
  }
`

export const ServicesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2.5rem;

  max-width: 1310px;
  width: 100%;
  padding: 0px 15px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 75rem) {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-gap: 1.5625rem;
  }

  @media (max-width: 30rem) {
    flex-direction: row;
    width: 97.5rem;
  }
`

export const ServicesSubTitle = styled.p`
  max-width: 19.5rem;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  display: flex;
  align-items: flex-end;
  color: #646981;
  margin-bottom: 4.375rem;

  @media (max-width: 75rem) {
    display: none;
  }
`

export const ServicesSubText = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h3 {
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1;
    color: #ffffff;
    margin: 0.625rem 0 0 0.1875rem;
  }
  p {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.0625rem;
    letter-spacing: -0.0125rem;
    color: #ffffff;
    margin: 0.625rem auto;
  }

  @media (max-width: 30rem) {
    padding-top: 0.8125rem;
    h3 {
      text-align: left;
      font-size: 1.125rem;
      line-height: 2.3125rem;
    }
    p {
      text-align: left;
      font-size: 0.8125rem;
      margin: 0 -0.4375rem 0 0.1875rem;
    }
  }
`

export const ServicesIcone = styled.div`
  background: #ffffff;
  box-shadow: 0rem 0.25rem 0.5625rem rgba(26, 27, 33, 0.17);
  border-radius: 0.6084rem;
  width: fit-content;
  padding: 0.75rem;
  margin-right: 2.0625rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -1.875rem;

  .image-icon-services {
    max-width: 2.5rem;
    max-height: 2.5rem;
  }

  @media (max-width: 30rem) {
    margin-right: 0.9375rem;
    width: 6.25rem;
    height: 3.125rem;
    margin-top: -1.25rem;
    padding: 0.313rem;
  }
`

export const ServicesInfo = styled.div<ServicesInfoProps>`
  position: relative;
  z-index: 1;
  background: ${({ darkTheme }) =>
    darkTheme
      ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
      : 'linear-gradient(89.74deg, #5C33FF 3.91%, #3399FF 98.18%)'};
  border-radius: 0rem 0rem 0.5rem 0.5rem;
  padding-left: 2.125rem;
  padding-bottom: 0.9375rem;
  display: flex;
  align-items: flex-start;
  height: 6.875rem;

  @media (max-width: 30rem) {
    padding: 0rem 0.9375rem;
    padding-bottom: 1.125rem;
  }
`

export const ServicesImage = styled.div`
  overflow: hidden;
  height: 17.75rem;
  width: 100%;
  border-radius: 0.5rem 0.5rem 0rem 0rem;
  position: relative;
  img {
    width: 25rem;
    max-width: initial;
    object-fit: cover;
    transform: scale(1);
    transition: all 0.3s;
  }
`

export const ServicesLink = styled.a`
  display: block;
  width: 100%;

  &:hover {
    ${ServicesImage} {
      img {
        transform: scale(1.05);
        transition: all 0.3s;
      }
    }
  }

  @media (max-width: 75rem) {
    ${ServicesImage} {
      img {
        width: 100%;
      }
    }
  }
  @media (max-width: 30rem) {
    height: auto;
    overflow: hidden;
  }
`

export const ServicesText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 1;
  grid-column-end: 2;
  margin-top: 5.3125rem;

  ${ServicesLink} {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    ${ServicesImage} {
      padding-top: 110.7%;
      height: 0;
    }
    ${ServicesInfo} {
      ${ServicesIcone} {
        margin-right: 1.4375rem;
      }
      ${ServicesSubText} {
        p {
          margin-bottom: 0rem;
          max-width: 19.5rem;
        }
      }
    }

    @media (max-width: 30rem) {
      width: 18.3125rem;
      height: 24.0625rem;
      margin-bottom: 0;
      ${ServicesImage} {
        height: 17.25rem;
        overflow: hidden;
        padding-top: 0;
      }
      ${ServicesInfo} {
        ${ServicesIcone} {
          margin-right: 0.6875rem;
          width: fit-content;
        }
        ${ServicesSubText} {
          p {
            display: block;
          }
        }
      }
    }

    @media (max-width: 75rem) {
      ${ServicesInfo} {
        ${ServicesSubText} {
          p {
            max-width: 100%;
          }
        }
      }
    }
  }

  h2 {
    color: #363843;
    font-size: 2rem;
    line-height: 2.3125rem;
    font-weight: bold;
    margin-bottom: 0.625rem;
  }

  @media (max-width: 75rem) {
    width: 100%;
    margin-top: 0rem;
    h2 {
      text-align: center;
      display: none;
    }
    p {
      text-align: left;
      max-width: 100%;
      margin: 0 auto;
      margin-bottom: 1.25rem;
    }
  }
`
